import moment from 'moment';
import { getToken } from './token';

export const getMinutesDiffs = () => {
  const loggedUser = getToken();
  return moment(loggedUser?.expires).diff(moment(), 'minutes');
};
